import api from "@/lib/axios";


const getErrors = (errors) => {
    const te = [];
    Object.keys(errors).forEach(key => te.push(errors[key][0]));
    return te;
}


export const vacancyService = {
    // create vacancy
    createVacancy: async (vacancyData) => {
        try {
            const response = await api.post("/vacancies", vacancyData);
            return response.data;
        } catch (error) {
            console.log("error messagge",error)
            if (error.response) {
              const apiError = error.response.data;
              const message = apiError.message || 'Validation error occurred';
          
              // Extract specific field errors (e.g., email)
              const fieldErrors = apiError.errors || {};
              // const emailError = fieldErrors.email ? fieldErrors.email[0] : null;
          
              console.log('General Message:', message);
              throw new Error("Failed to create vacancy: " + message);
             
            } else {
              console.log('An unexpected error occurred:', error.message);
              throw new Error("Failed to create vacancy: " + error.message);
            }
          }
    },


    // get all vacancies
    getAllVacancies: async (params) => {
        try {
            const response = await api.get("/vacancies", {params});
            return response.data;
        } catch (error) {
            throw new Error("Failed to get all vacancies: " + error.message);
        }
    },

    // get vacacny by campaign id
    getVacancyByCampaignId: async (campaignId, params) => {
        try {
            const response = await api.get(`/campaign/vacancies/${campaignId}`, {params});
            return response.data;
        } catch (error) {
            throw new Error("Failed to get vacancy by campaign id: " + error.message);
        }
    },


    //get all vacancies by company id
    getAllVacanciesByCompanyId: async (companyId, params) => {
        try {
            const response = await api.get(`/company/${companyId}/vacancies`, {
                params: {
                    ...params
                }
            });
            return response.data;
        } catch (error) {
            throw new Error("Failed to get all vacancies by company id: " + error.message);
        }
    },

    // update vacancy
    updateVacancy: async (vacancyId, vacancyData) => {
        try {
            const response = await api.put(`/vacancies/${vacancyId}`, vacancyData);
            return response.data;
        } catch (error) {
            console.log("error messagge",error)
            // Preserve the original error structure so error_details can be accessed
            if (error.response) {
              // Throw the original error to preserve error.response.data structure
              throw error;
            } else {
              console.log('An unexpected error occurred:', error.message);
              throw new Error("Failed to update vacancy: " + error.message);
            }
          }
    },

    //get vacancy by id
    getVacancyById: async (vacancyId) => {
        try {
            const response = await api.get(`/vacancies/${vacancyId}`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to get vacancy by id: " + error.message);
        }
    },

    // delete vacancy
    deleteVacancy: async (vacancyId) => {
        try {
            const response = await api.delete(`/vacancies/${vacancyId}`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to delete vacancy: " + error.message);
        }
    },


    // get comany vacancies
    getCompanyVacancies: async (companyId, params) => {
        try {
            const response = await api.get(`/company/${companyId}/vacancies`, {
                params: {
                    ...params
                }
            });
            return response.data;
        } catch (error) {
            throw new Error("Failed to get company vacancies: " + error.message);
        }
    },

    updateVacancyStatus: async (vacancyId, payload) => {
        try {
          const response = await api.post(`/vacancy/status/${vacancyId}`, 
            payload, // Send the complete payload
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            }
          );
          return response.data;
        } catch (error) {
          if (error.response) {
            const apiError = error.response.data;
            const message = apiError.message || 'Failed to update vacancy status';
            throw new Error(message);
          } else {
            throw new Error("Failed to update vacancy status: " + error.message);
          }
        }
    },
    getVacancies: async (company_id, params) => {
      try {
        const { data } = await api.get("/vacancy/listing", {
          params: {
            company_id,
            ...params
          }
        });
        return data;
      } catch (error) {
        throw new Error("Failed to fetch vacancies: " + error.message);
      }
    },
}
